export var IdRandomPools;
(function (IdRandomPools) {
    IdRandomPools[IdRandomPools["DogPoolStandard"] = 1] = "DogPoolStandard";
    IdRandomPools[IdRandomPools["DogPoolPremium"] = 8] = "DogPoolPremium";
})(IdRandomPools || (IdRandomPools = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdRandomPools.ts
// module id = 601
// module chunks = 3